// @flow
import {PageTitle} from 'componentsStyled/Typography/Titles';
import styled from 'styled-components';

export const StyledTitle = styled(PageTitle)`
  padding: 0;
  font-size: 2.6rem;
`;
